import { DEFAULT_TAG_COLOR } from 'src/service/tag/constants';
import { Rotation } from 'src/types';
import moment from 'moment';

export function hexToRgb(hex: string = DEFAULT_TAG_COLOR.hex, decimal?: boolean) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const r = result ? parseInt(result[1], 16) : DEFAULT_TAG_COLOR.rgb.r;
  const g = result ? parseInt(result[2], 16) : DEFAULT_TAG_COLOR.rgb.g;
  const b = result ? parseInt(result[3], 16) : DEFAULT_TAG_COLOR.rgb.b;
  return decimal ? { r: r / 255, g: g / 255, b: b / 255 } : { r, g, b };
}

export function getBaseURL() {
  return window.location.href.split('?')[0];
}

export function buildLink(s: string, rotation: Rotation, m: any = null) {
  let link = `${getBaseURL()}?s=${s}&x=${rotation.x}&y=${rotation.y}`;
  if (m) link += `&m=${m}`;
  const ticket = new URLSearchParams(window.location.search).get('ticket');
  if (ticket && ticket.length > 0) link += `&ticket=${ticket}`;
  return link;
}

export function getVersion(date: Date) {
  return moment().diff(date, 'days') === 0 ? '?v=' + moment(date).format('HHmmss') : '';
}

export const getMeshUrl = (url: string, updatedAt: Date) =>
  `${process.env.NEXT_PUBLIC_CDN}${url}${getVersion(updatedAt)}`;

export const meshMaterialChange = (material: any) => {
  if (material.metalness >= 0.9) {
    material.metalness = 0.7;
    material.roughness = 0.4;
  }
  return material;
};

export const hexToRGBA = (hex: string, alpha: number): string => {
  // If already rgba, just replace the alpha value
  if (hex.includes('rgba')) {
    const regex = /(,)(?=[^,]*$).*$/;
    return hex.replace(regex, `, ${alpha})`);
  }

  if (hex.length === 4) {
    hex = `#${hex
      .replace('#', '')
      .split('')
      .map((char) => char + char)
      .join('')}`;
  }
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const removeHTMLTagsFromString = (str: string) => {
  if (!str) return '';
  return str
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};
